import { Typography, Tooltip } from "@mui/material";
import React, { useRef, useState, useEffect, useCallback } from "react";

interface CellTextProps {
  children: string;
}

const CellText = ({ children }: CellTextProps) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const checkTruncation = useCallback(() => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, []);

  // useEffect(() => {
  //   checkTruncation();

  //   // Resize Observer to detect column resizing in DataGrid
  //   const resizeObserver = new ResizeObserver(() => {
  //     checkTruncation();
  //   });

  //   if (textRef.current) {
  //     resizeObserver.observe(textRef.current);
  //   }

  //   return () => {
  //     if (textRef.current) {
  //       resizeObserver.unobserve(textRef.current);
  //     }
  //   };
  // }, [checkTruncation, children]);

  const textComponent = (
    <Typography
      variant="body2"
      color="text.primary"
      ref={textRef}
      component="span"
      sx={{
        display: "inline-block",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "100%",
      }}
    >
      {children}
    </Typography>
  );

  return isTruncated ? (
    <Tooltip title={children}>{textComponent}</Tooltip>
  ) : (
    textComponent
  );
};

export default CellText;
